import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { justifiInlineStyles, justifiOverrideStyles } from '../global.styles';

export const inlineStyles = (shouldHideRadioListItem: boolean) =>
  css([justifiInlineStyles, shouldHideRadioListItem && hideRadioListItem]).styles.replaceAll(/;;\n?/g, '\n');

export const overrideStyles = css`
  ${justifiOverrideStyles.styles}
  hidden-input {
    display: none;
    height: 0;
    overflow: hidden;
  }

  .payment-method .mt-4.pb-4 {
    margin-top: ${theme.spacing(2)} !important;
  }

  .row > .align-content-end {
    align-content: flex-start !important;
  }
`.styles;

export const hideRadioListItem = css`
  ::part(radio-list-item) {
    display: none;
  }
`;
